import { render, staticRenderFns } from "./POIGeneralState.vue?vue&type=template&id=5c773d57"
import script from "./POIGeneralState.js?vue&type=script&lang=js&external"
export * from "./POIGeneralState.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports